import { createApiSlice } from "@common";
import {
  GET_DOMAIN_BY_INDUSTRY,
  GET_INDUSTRY_TYPE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getIndustyType",
    method: "get",
    url: GET_INDUSTRY_TYPE,
    stateKey: "data",
  },
  {
    name: "getDomainByIndustry",
    method: "get",
    url: GET_DOMAIN_BY_INDUSTRY,
    stateKey: "domainData",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    domainData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "industyType",
  apiConfig,
  customReducers,
);
const industyTypeSlice = slice;
// Export the slice's reducer
export default industyTypeSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  getIndustyType,
  getDomainByIndustry,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
